import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { initAuthDefaultFlow } from './auth-flows/default-flow';
// Types

/**
 * Auth plugin for Nuxt using Auth0.
 *
 * @param {Context} context
 * @param {Inject} inject
 */
export var auth = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, inject) {
    var app, $config, route, path, basePath, authFlow, auth;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          app = _ref.app, $config = _ref.$config, route = _ref.route;
          path = window.location.pathname;
          basePath = path.split('/').filter(Boolean)[0];
          _context.t0 = basePath;
          _context.next = _context.t0 === 'lounge-portal' ? 6 : 9;
          break;
        case 6:
          // TODO can remove the console logs once the work is complete, leaving in for now to help debug
          console.log('lounge-portal');
          authFlow = initAuthDefaultFlow({
            app: app,
            $config: $config,
            route: route
          });
          return _context.abrupt("break", 11);
        case 9:
          console.log('default-auth');
          authFlow = initAuthDefaultFlow({
            app: app,
            $config: $config,
            route: route
          });
        case 11:
          auth = authFlow;
          _context.next = 14;
          return auth.initAuth();
        case 14:
          inject('auth', auth);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function auth(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default auth;